<script setup="">
import { computed, ref, watch } from "vue";

import { useColor } from "@/composables/color";
import { useScrollStore } from "@/stores/scroll";

const props = defineProps({
  campaign: {
    type: Object,
    required: true
  }
});

const scroll = useScrollStore();
const color = useColor();

const bgLightColor = ref();

const bgColor = computed(() => props.campaign.settings.background_color);
bgLightColor.value = color.getLightnessColor(bgColor.value);

watch(
  () => bgColor.value,
  (value) => (bgLightColor.value = color.getLightnessColor(value))
);
</script>

<template>
  <div v-if="scroll.getScrollTop > 50" class="fixed inset-x-0 top-0 z-30 h-[var(--ios-padding-top)] bg-campaign"></div>
  <!--end::isp-cover-->

  <div class="pointer-events-none fixed inset-0 z-0 select-none overflow-hidden">
    <div class="absolute inset-0 overflow-hidden bg-cover" :style="{ backgroundColor: bgLightColor }"></div>
  </div>
</template>
